// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orderDetailTransport {\n  padding: 24px 32px;\n}\n.orderDetailTransport .btnBox {\n  text-align: right;\n  margin-bottom: 16px;\n}", ""]);
// Exports
module.exports = exports;
